import { SelectOption } from '@globaleris/ui.library'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EmpresaResponse } from '../../model/Subject'
import { Sujeto } from '../../..'

export const fetchSubjectsAPI = async (
  subjectTypes: number[],
  balanceZone: number | null
): Promise<SelectOption[]> => {
  return await AxiosInstance.post(
    `${getAppConfigurationValue(
      AppConfigurationKey.ApiUrlSuffixPioneer
    )}/api/subjects/FetchSelectOptions`,
    { subjectTypes: subjectTypes, balanceZone: balanceZone }
  ).then(response => {
    return response.data
  })
}

export const fetchBrokerAPI = async (
  subjectTypes: number[],
  balanceZone: number
): Promise<SelectOption[]> => {
  return await AxiosInstance.post(
    `${getAppConfigurationValue(
      AppConfigurationKey.ApiUrlSuffixPioneer
    )}/api/subjects/FetchBrokerSelectOptions`,
    { subjectTypes: subjectTypes, balanceZone: balanceZone }
  ).then(response => {
    return response.data
  })
}

export const apiSujetosGetEmpresasGET = async (): Promise<EmpresaResponse[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Company/FetchVisibleCompanies`).then(
    response => {
      return response.data
    }
  )
}

export const fetchSubjectsByTypesAPI = async (
  subjectTypes: number[],
  commodity?: number,
  balanceZone?: number
): Promise<Sujeto[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/subjects/FetchByTypes`, {
    subjectTypes: subjectTypes,
    commodity: commodity,
    balanceZone: balanceZone
  }).then(response => {
    return response.data
  })
}

export const fetchSubjectByIdAPI = async (id: number): Promise<Sujeto> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/subjects/${id}`).then(response => {
    return response.data
  })
}
